(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('testimonials-kq-carousel')) return;

  class TestimonialsKqCarousel extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.drag = null;
      this.suppressClick = false;
      this.mobile.addEventListener('change', () => {
        this.finishDrag();
        this.updateState();
      }, options);
      this.addEventListener('pointerdown', (event) => this.startDrag(event), options);
      this.addEventListener('pointermove', (event) => this.moveDrag(event), options);
      this.addEventListener('pointerup', () => this.finishDrag(), options);
      this.addEventListener('pointercancel', () => this.finishDrag(), options);
      this.addEventListener('lostpointercapture', () => this.finishDrag(), options);
      this.addEventListener('dragstart', (event) => {
        if (this.canDrag) event.preventDefault();
      }, options);
      this.addEventListener('click', (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, { ...options, capture: true });
      this.addEventListener('keydown', (event) => this.onKeydown(event), options);
      this.resizeObserver = new ResizeObserver(() => this.updateState());
      this.resizeObserver.observe(this);
      this.updateState();
    }

    disconnectedCallback() {
      this.finishDrag();
      clearTimeout(this.clickTimer);
      this.resizeObserver?.disconnect();
      this.events?.abort();
    }

    updateState() {
      this.canDrag = this.mobile.matches
        && this.dataset.mobileLayout === 'carousel'
        && this.scrollWidth > this.clientWidth + 1;
      this.toggleAttribute('data-draggable', this.canDrag);
      this.tabIndex = this.canDrag ? 0 : -1;
    }

    startDrag(event) {
      if (!this.canDrag || event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
      if (event.target.closest('a, button, input, textarea, select, summary')) return;
      this.suppressClick = false;
      clearTimeout(this.clickTimer);
      this.drag = { id: event.pointerId, x: event.clientX, scroll: this.scrollLeft, moved: false };
      this.setPointerCapture(event.pointerId);
      // Touch and trackpad gestures use native scrolling; only mouse dragging
      // is handled here. Vertical page scrolling is never canceled for touch.
    }

    moveDrag(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      if (event.buttons === 0) {
        this.finishDrag();
        return;
      }
      const delta = event.clientX - this.drag.x;
      if (!this.drag.moved && Math.abs(delta) < 6) return;
      this.drag.moved = true;
      this.classList.add('is-dragging');
      this.style.scrollSnapType = 'none';
      this.style.scrollBehavior = 'auto';
      this.scrollLeft = this.drag.scroll - delta;
      event.preventDefault();
    }

    finishDrag() {
      if (!this.drag) return;
      const { id, moved } = this.drag;
      this.drag = null;
      this.classList.remove('is-dragging');
      this.style.removeProperty('scroll-snap-type');
      this.style.removeProperty('scroll-behavior');
      this.suppressClick = moved;
      if (this.hasPointerCapture(id)) this.releasePointerCapture(id);
      // Re-enabling CSS scroll snapping settles onto the nearest card.
      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
    }

    onKeydown(event) {
      if (!this.canDrag || event.target !== this || event.ctrlKey || event.metaKey || event.altKey) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const card = this.querySelector('.testimonials-kq__card');
      if (!card) return;
      event.preventDefault();
      const styles = window.getComputedStyle(this);
      const step = card.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
      const behavior = this.motion.matches ? 'auto' : 'smooth';
      const rtl = styles.direction === 'rtl';
      if (event.key === 'Home' || event.key === 'End') {
        const limit = Math.max(0, this.scrollWidth - this.clientWidth);
        this.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -limit : limit), behavior });
      } else {
        this.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior });
      }
    }
  }

  customElements.define('testimonials-kq-carousel', TestimonialsKqCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-accordion')) {
  class ImageAccordion extends HTMLElement {
    connectedCallback() {
      this.stopPlayback();
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]'));
      this.images = Array.from(this.querySelectorAll('[data-accordion-image]'));
      this.faq = this.querySelector('[data-accordion-faq]');
      this.duration = Math.max(3, Number(this.dataset.switchInterval) || 6) * 1000;
      this.remaining = this.duration;
      this.enabled = this.dataset.autoSwitch === 'true' && this.items.length > 1;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = !!this.faq?.matches(':hover') && window.matchMedia('(hover: hover)').matches;
      this.focused = false;
      this.keyboardInteraction = false;
      this.editorPaused = false;
      this.visible = !('IntersectionObserver' in window);
      this.frame = null;
      this.lastTime = null;
      this.tick = this.tick.bind(this);
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', () => this.openItem(Number(trigger.dataset.accordionTrigger)), options);
      });
      // Listen on the FAQ column: moving between its questions does not restart the timer.
      this.faq?.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.syncPlayback();
      }, options);
      this.faq?.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = false;
        this.syncPlayback();
      }, options);
      // Mouse clicks may leave a button focused; that must not prevent hover-out resuming.
      document.addEventListener('pointerdown', () => {
        this.keyboardInteraction = false;
        this.focused = false;
        this.syncPlayback();
      }, options);
      document.addEventListener('keydown', () => {
        this.keyboardInteraction = true;
        if (this.contains(document.activeElement)) {
          this.focused = true;
          this.syncPlayback();
        }
      }, options);
      this.addEventListener('focusin', () => {
        this.focused = this.keyboardInteraction;
        this.syncPlayback();
      }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.keyboardInteraction && !!event.relatedTarget && this.contains(event.relatedTarget);
        this.syncPlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => this.syncPlayback(), options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const block = event.target.closest('[data-block-id]');
        const item = this.items.find(item => item.dataset.blockId === block?.dataset.blockId);
        if (item) {
          this.editorPaused = !!window.Shopify?.designMode;
          this.openItem(Number(item.dataset.accordionItem));
        }
      }, options);
      document.addEventListener('shopify:block:deselect', event => {
        if (!this.contains(event.target)) return;
        this.editorPaused = false;
        this.syncPlayback();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.syncPlayback();
        }, { threshold: 0.1 });
        this.observer.observe(this);
      }
      this.openItem(Number(this.dataset.activeIndex) || 1);
    }
    disconnectedCallback() {
      this.stopPlayback();
      this.events?.abort();
      this.observer?.disconnect();
    }
    openItem(index) {
      if (!this.items.some(item => Number(item.dataset.accordionItem) === index)) return;
      this.stopPlayback();
      this.activeIndex = index;
      this.dataset.activeIndex = String(index);
      this.items.forEach(item => {
        const active = Number(item.dataset.accordionItem) === index;
        item.classList.toggle('is-active', active);
        item.style.setProperty('--ia-progress', '0');
        item.querySelector('[data-accordion-trigger]')?.setAttribute('aria-expanded', String(active));
        const panel = item.querySelector('[data-accordion-panel]');
        if (panel) {
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        }
      });
      this.images.forEach(image => {
        const active = Number(image.dataset.accordionImage) === index;
        image.classList.toggle('is-active', active);
        image.setAttribute('aria-hidden', String(!active));
      });
      this.remaining = this.duration;
      this.syncPlayback();
    }
    syncPlayback() {
      const shouldPlay = this.enabled && !this.motion.matches && !this.hovered && !this.focused && !this.editorPaused && !document.hidden && this.visible;
      if (!shouldPlay) {
        this.stopPlayback();
      } else if (this.frame === null) {
        this.lastTime = performance.now();
        this.frame = requestAnimationFrame(this.tick);
      }
    }
    stopPlayback() {
      if (this.frame !== null && this.frame !== undefined) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.lastTime = null;
    }
    tick(time) {
      this.frame = null;
      this.remaining -= Math.max(0, time - this.lastTime);
      this.lastTime = time;
      const item = this.items.find(item => Number(item.dataset.accordionItem) === this.activeIndex);
      item?.style.setProperty('--ia-progress', String(Math.min(1, Math.max(0, 1 - this.remaining / this.duration))));
      if (this.remaining <= 0) {
        const position = this.items.indexOf(item);
        this.openItem(Number(this.items[(position + 1) % this.items.length].dataset.accordionItem));
      } else {
        this.frame = requestAnimationFrame(this.tick);
      }
    }
  }
  customElements.define('image-accordion', ImageAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

// Delegated clicks include cards added by filtering and infinite scrolling.
if (!customElements.get('hamamat-restock-dialog')) {
  class HamamatRestockDialog extends HTMLElement {
    #events;
    #trigger;
    #product;

    connectedCallback() {
      this.#events?.abort();
      this.#events = new AbortController();
      const { signal } = this.#events;
      document.addEventListener('click', this.#onDocumentClick, { signal });
      this.addEventListener('change', this.#onChange, { signal });
      this.addEventListener('submit', this.#onSubmit, { signal });
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      dialog.addEventListener('click', this.#onDialogClick, { signal });
      dialog.addEventListener('close', this.#onClose, { signal });
      queueMicrotask(() => this.#restoreResponse());
    }

    disconnectedCallback() {
      this.#events?.abort();
      this.querySelector('dialog')?.close();
    }

    #storageKey() {
      return `hamamat-restock:${this.dataset.sectionId}:${window.location.pathname}`;
    }

    #onDocumentClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-restock-open]');
      if (!trigger || trigger.dataset.restockSection !== this.dataset.sectionId) return;
      const template = trigger.closest('li')?.querySelector('template[data-restock-variants]');
      if (!(template instanceof HTMLTemplateElement)) return;
      event.preventDefault();
      this.#trigger = trigger;
      const variants = Array.from(template.content.querySelectorAll('option'), (option) => ({
        id: option.value,
        title: option.textContent || '',
      }));
      this.#setProduct({
        id: trigger.dataset.productId || '',
        title: trigger.dataset.productTitle || '',
        url: new URL(trigger.dataset.productUrl || '/', window.location.origin).href,
        variants,
      });
      this.#resetFeedback();
      this.#open();
    };

    #setProduct(product) {
      this.#product = product;
      this.querySelector('[data-restock-product-name]').textContent = product.title;
      this.querySelector('[data-restock-product-field]').value = product.title;
      this.querySelector('[data-restock-product-id-field]').value = product.id;
      this.querySelector('[data-restock-product-url-field]').value = product.url;
      const select = this.querySelector('[data-restock-variant-select]');
      select.replaceChildren(...product.variants.map((variant) => new Option(variant.title, variant.id)));
      this.querySelector('[data-restock-variant-row]').hidden = product.variants.length < 2;
      if (product.variantId) select.value = product.variantId;
      this.#syncVariant();
    }

    #syncVariant() {
      if (!this.#product) return;
      const select = this.querySelector('[data-restock-variant-select]');
      const option = select.selectedOptions[0];
      if (!option) return;
      const title = option.textContent || '';
      this.querySelector('[data-restock-variant-id-field]').value = option.value;
      this.querySelector('[data-restock-variant-title-field]').value = title;
      this.#product.variantId = option.value;
      this.querySelector('[data-restock-body-field]').value = [
        'Please contact me when this product is available again.',
        `Product: ${this.#product.title}`,
        `Product ID: ${this.#product.id}`,
        `Option: ${title}`,
        `Variant ID: ${option.value}`,
        `Product URL: ${this.#product.url}`,
      ].join('\n');
    }

    #onChange = (event) => {
      if (event.target instanceof Element && event.target.matches('[data-restock-variant-select]')) {
        this.#syncVariant();
      }
    };

    #onSubmit = (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (!this.#product) { event.preventDefault(); return; }
      this.#syncVariant();
      // Keep locale, preview parameters, filters, sorting and page on return.
      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.delete('contact_posted');
      returnUrl.hash = event.target.id;
      const returnInput = event.target.querySelector('[name="return_to"]');
      if (returnInput) returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      // Store only product context, never the visitor's email address.
      try {
        sessionStorage.setItem(this.#storageKey(), JSON.stringify({ product: this.#product, submittedAt: Date.now() }));
      } catch {}
      // Native submission preserves Shopify validation and CAPTCHA handling.
    };

    #resetFeedback() {
      this.querySelectorAll('[data-restock-feedback]').forEach((feedback) => { feedback.hidden = true; });
      this.querySelector('[data-restock-fields]').hidden = false;
      this.querySelector('.collection-restock-dialog__description').textContent = 'Leave your email to request an availability update from our team.';
    }

    #restoreResponse() {
      if (!this.isConnected) return;
      const feedback = this.querySelector('[data-restock-feedback]');
      if (!feedback || window.location.hash !== '#' + this.querySelector('form').id) return;
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(this.#storageKey()) || 'null'); } catch {}
      const hasProduct = saved?.product && Array.isArray(saved.product.variants) && Date.now() - saved.submittedAt < 30 * 60 * 1000;
      if (hasProduct) this.#setProduct(saved.product);
      feedback.hidden = false;
      this.querySelector('[data-restock-fields]').hidden = feedback.dataset.restockState === 'success' || !hasProduct;
      if (!hasProduct && feedback.dataset.restockState === 'error') {
        this.querySelector('.collection-restock-dialog__description').textContent = 'Please close this window and click the product notification button again to retry.';
      }
      this.#open(feedback);
      if (feedback.dataset.restockState === 'success') {
        try { sessionStorage.removeItem(this.#storageKey()); } catch {}
      }
    }

    #open(focusTarget) {
      const dialog = this.querySelector('dialog');
      if (!dialog || dialog.open) return;
      dialog.showModal();
      (focusTarget || this.querySelector('[data-restock-email]'))?.focus({ preventScroll: true });
    }

    #onDialogClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const dialog = this.querySelector('dialog');
      if (event.target.closest('[data-restock-close]')) {
        dialog.close();
      } else if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    };

    #onClose = () => {
      if (this.#trigger?.isConnected) this.#trigger.focus({ preventScroll: true });
    };
  }
  customElements.define('hamamat-restock-dialog', HamamatRestockDialog);
}


  } catch(e) { console.error(e); }
})();
})();
